(function($) {
  'use strict';
  var j = $.noConflict();


  j(document).ready(function(){




    j('.slick').slick({
      arrows: true,
      // appendArrows: $('.btns'),
      draggable: false,
      prevArrow: '.left-arrow',
      nextArrow: '.right-arrow',
    });



  });

}(jQuery));
